<template>
    <span class="sms-badge" :class="cls" :title="title">
        <i :class="meta.icon"></i>
        <span class="sms-badge-label">{{ label }}</span>
    </span>
</template>

<script>
// 2026-05-23 — Task 16.5: SmsBadge.vue
// Renders a coloured pill for the SMS "kind" classification emitted by the
// backend (ClassifyKind on SmsSimulatorController). Keeps the SmsSimulator
// timeline visually scannable so QA can tell OTP from welcome from
// lifecycle/operational at a glance.

const KIND = {
    Otp:         { icon: 'ti ti-key',           cls: 'kind-otp',         label: 'OTP',         title: 'رمز التحقق (OTP)' },
    Welcome:     { icon: 'ti ti-user-plus',     cls: 'kind-welcome',     label: 'Welcome',     title: 'رسالة ترحيب / كلمة مرور مؤقتة' },
    Lifecycle:   { icon: 'ti ti-route',         cls: 'kind-lifecycle',   label: 'Lifecycle',   title: 'دورة الرحلة (استلام / توصيل / بدء / نهاية)' },
    Operational: { icon: 'ti ti-alert-triangle',cls: 'kind-operational', label: 'Operational', title: 'تشغيلية (طوارئ / تأخير / تنبيه)' },
    Other:       { icon: 'ti ti-message',       cls: 'kind-other',       label: 'Other',       title: 'أخرى' },
};

export default {
    name: 'SmsBadge',
    props: {
        kind: { type: String, default: 'Other' }
    },
    computed: {
        meta() { return KIND[this.kind] || KIND.Other; },
        cls()   { return this.meta.cls; },
        label() { return this.meta.label; },
        title() { return this.meta.title; }
    }
};
</script>

<style scoped>
    .sms-badge {
        display: inline-flex; align-items: center; gap: 5px;
        padding: 4px 10px; border-radius: 999px;
        font-size: 12px; font-weight: 800; line-height: 1;
        border: 1px solid transparent;
    }
    .sms-badge i { font-size: 14px; }
    .sms-badge-label { white-space: nowrap; }

    .kind-otp         { background: #ede9fe; color: #5b21b6; border-color: #ddd6fe; }
    .kind-welcome     { background: #d1fae5; color: #065f46; border-color: #a7f3d0; }
    .kind-lifecycle   { background: #dbeafe; color: #1e40af; border-color: #bfdbfe; }
    .kind-operational { background: #fee2e2; color: #991b1b; border-color: #fecaca; }
    .kind-other       { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }
</style>
